import * as React from "react";
const SvgSignalCellularNullOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M20 6.83V20H6.83L20 6.83M22 2 2 22h20V2z" />
  </svg>
);
export default SvgSignalCellularNullOutlined;
